const actions = {
  BULK_ACTIVATION: "BULK_ACTIVATION",
  BULK_ACTIVATION_SUCCESS: "BULK_ACTIVATION_SUCCESS",
  BULK_ACTIVATION_FAILED: "BULK_ACTIVATION_FAILED",

  GET_AVAILABLE_ICCID: "GET_AVAILABLE_ICCID",
  GET_AVAILABLE_ICCID_SUCCESS: "GET_AVAILABLE_ICCID_SUCCESS",
  GET_AVAILABLE_ICCID_FAILED: "GET_AVAILABLE_ICCID_FAILED",

  RESET_MESSAGE: "RESET_MESSAGE",

  createBulkActivation: (data) => ({
    type: actions.BULK_ACTIVATION,
    payload: { data },
  }),
  createBulkActivationSuccess: (message, data) => ({
    type: actions.BULK_ACTIVATION_SUCCESS,
    payload: { message, data }
  }),
  createBulkActivationFailed: (error, data) => ({
    type: actions.BULK_ACTIVATION_FAILED,
    payload: { error, data },
  }),

  getAvailableICCID: () => ({
    type: actions.GET_AVAILABLE_ICCID,
  }),
  getAvailableICCIDSuccess: (message, data) => ({
    type: actions.GET_AVAILABLE_ICCID_SUCCESS,
    payload: { message, data }
  }),
  getAvailableICCIDFailed: (error) => ({
    type: actions.GET_AVAILABLE_ICCID_FAILED,
    payload: { error },
  }),

  resetMessage: () => ({
    type: actions.RESET_MESSAGE,
  }),


}

export default actions;